<script setup lang="ts">
import { computed } from 'vue';
import { operatingSystem } from '../lib/operating-system.js';
import { osIconPaths } from './os-icon-paths.js';

const props = defineProps<{ platform: string; version?: string | undefined }>();
const system = computed(() => operatingSystem(props.platform, props.version));
</script>

<template>
  <svg
    v-if="system"
    class="os-icon"
    :data-os="system.icon"
    viewBox="0 0 24 24"
    fill="currentColor"
    role="img"
    :aria-label="system.label"
  >
    <title>{{ system.label }}</title>
    <path :d="osIconPaths[system.icon]" />
  </svg>
</template>
